"use client";

import type { QueryClientProviderProps } from "@tanstack/react-query";

import { DataProvider } from "../data/providers/DataProvider";
import type { SessionProviderProps } from "../session/providers/SessionProvider";
import { SessionProvider } from "../session/providers/SessionProvider";
import { LocaleProvider } from "./LocaleProvider";
import { OpenApiProvider } from "./OpenApiProvider";

export type SdkProviderProps = Omit<QueryClientProviderProps, "client"> &
  Pick<SessionProviderProps, "noAutoRefresh">;

export const SdkProvider = ({
  children,
  noAutoRefresh,
  ...props
}: SdkProviderProps) => (
  <SessionProvider noAutoRefresh={noAutoRefresh}>
    <DataProvider {...props}>
      <LocaleProvider>
        <OpenApiProvider>{children}</OpenApiProvider>
      </LocaleProvider>
    </DataProvider>
  </SessionProvider>
);
